<div *ngIf="cs.vm$ | async as vm">
  <div class="checkout-hero-banner">
    <dgx-components-picture
      [alt]="'{{vm.clientName}}-checkout-banner'"
      [fill]="true"
      [fit]="'cover'"
      [position]="'center'"
      [src]="
        'assets/images/checkout-banner/' +
        (vm.clientName | lowercase) +
        '-checkout-banner-' +
        (vm.isDesktop ? 'desktop' : 'mobile') +
        '.png'
      "
      class="checkout-hero-banner__picture"
    />

    <div class="checkout__hero-banner-title-panel">
      <h1 class="checkout__hero-banner-title-panel-text typog-h2">
        {{ 'CHECKOUT_BANNER_TITLE' | translate : { firstName: vm.firstName } }}
        <br />
        {{
          'CHECKOUT_BANNER_TITLE_BRAND'
            | translate : { brandName: vm.clientName }
        }}
      </h1>
    </div>
  </div>

  <div class="my-4" id="checkout"></div>

  <div *ngIf="vm.checkoutLoading" class="checkout__loading-panel">
    <dgx-components-loading-overlay [loader]="vm.checkoutLoading" />
  </div>
</div>
